import { isAndroid } from 'APP/Helpers/checkPlatform'
import { NativeModules } from 'react-native'

const { SessionManager } = NativeModules

// TODO: add iOS at a later PR
export const configureOpenTokAudioForVideoCall = () => {
  if (isAndroid()) {
    return SessionManager?.configureAudioForVideoCall?.() || Promise.resolve()
  }
  return Promise.resolve()
}
